import { getPeriodLength } from "../ClockPeriod";
import { convertClock, convertClockWithMs } from "../ConvertClock";
import { toCatchupFilter } from "./ToCatchupFilter";

export async function multiDeviceClockCatchup(messages, currentState, updateState, fixtureProfile) {
  let tempPeriod = currentState.period ? currentState.period : { periodId: 0 };
  let tempClock = currentState.clock ? JSON.parse(JSON.stringify(currentState.clock)) : {};

  const toCatchupEvents = toCatchupFilter(messages, currentState).sort(function (a, b) {
    var aMixed = new Date(a.eventTime.replace("Z", ""));
    var bMixed = new Date(b.eventTime.replace("Z", ""));
    return aMixed < bMixed || a.periodId < b.periodId ? -1 : 1;
  });

  toCatchupEvents.forEach((event) => {
    if (event.periodId >= tempPeriod.periodId) {
      tempPeriod.periodId = event.periodId;
    }

    const handlePeriodEvent = () => {
      tempPeriod.periodId = event.periodId;
      switch (event.subType) {
        case "start":
          tempPeriod.periodStatus = "periodStarted";
          break;
        case "end":
          tempPeriod.periodStatus = "periodEnd";
          break;
        case "confirmed":
          if (tempPeriod.periodId >= fixtureProfile.numberOfPeriods) {
            tempPeriod.periodStatus = "pendingExtra";
          } else {
            tempPeriod.periodStatus = "pending";
            tempPeriod.periodId = tempPeriod.periodId + 1;
          }
          break;
        case "pending":
          if (event.periodId > 0) {
            tempPeriod.periodStatus = "pending";
            if (fixtureProfile.clockDirection === "COUNT_DOWN") {
              tempClock.displayTime = convertClock(`PT${getPeriodLength(event.periodId, fixtureProfile)}M0S`);
            } else {
              tempClock.displayTime = convertClock("PT0M0S");
            }
          }
          break;
        default:
          break;
      }
    };

    const handleFixtureEvent = () => {
      switch (event.subType) {
        case "end":
          tempPeriod.periodStatus = "fixtureConfirm";
          break;
        case "confirmed":
          tempPeriod.periodStatus = "fixtureComplete";
          break;
        default:
          break;
      }
    };

    const handleClockMainEvent = () => {
      if (event.class === "clock") {
        if (event.subType === "stop") {
          tempClock.clockRunning = false;
          const parsedTime = convertClockWithMs(event.clock);
          tempClock.displayTime = parsedTime[0];
          tempClock.msCatchup = parseInt(parsedTime[1], 10);
        }
        if (event.subType === "start") {
          tempClock.clockRunning = true;
          const deltaTime =
            new Date().getTime() - new Date(`${event.eventTime}${event.eventTime.includes("Z") ? "" : "Z"}`).getTime();
          const deltaSeconds = Math.floor(deltaTime / 1000);
          const deltaMs = deltaTime - deltaSeconds * 1000;
          const parsedTime = convertClockWithMs(event.clock);
          const splitTime = parsedTime[0].split(":");
          const msTime = parsedTime[1];
          let allSeconds;
          let msCatchup;
          if (fixtureProfile.clockDirection === "COUNT_DOWN") {
            allSeconds = parseInt(splitTime[0], 10) * 60 + parseInt(splitTime[1], 10) - deltaSeconds;
            msCatchup = Math.max(0, Math.min(999, parseInt(msTime, 10) - deltaMs));
          } else {
            allSeconds = parseInt(splitTime[0], 10) * 60 + parseInt(splitTime[1], 10) + deltaSeconds;
            msCatchup = Math.max(0, Math.min(999, parseInt(msTime, 10) + deltaMs));
          }
          const newMins = Math.floor(allSeconds / 60);
          const newSecs = allSeconds % 60;
          tempClock.displayTime = newMins + ":" + newSecs;
          tempClock.msCatchup = msCatchup;
        }
      }
    };

    switch (event.eventType) {
      case "period":
        handlePeriodEvent();
        break;
      case "fixture":
        handleFixtureEvent();
        break;
      case "main":
        handleClockMainEvent();
        break;
      default:
        break;
    }
  });

  if (toCatchupEvents.length > 0) {
    updateState("periodCatchup", tempPeriod);
    updateState("clockCatchup", tempClock);
  }
}
